<template>
  <div class="chatRobotFloor" v-if="isShow">
    <div class="chatTextarea">
      <textarea
        id="textarea"
        :placeholder="
          isQa == 1
            ? '请描述您的问题，如 “什么是循环流化床发电？'
            : '请描述您的问题，如 “请帮我写一个明早九点的会议通知？'
        "
        class="textarea"
        v-model="questionContent"
        rows="1"
        :disabled="isLock"
      ></textarea>
    </div>
  </div>
</template>

<script>
let fn = () => {}
export default {
  data() {
    return {
      questionContent: '',
      isShow: false
    }
  },
  props: {
    isLock: {
      type: Boolean,
      default: false
    },
    isQa: {
      type: [String, Number],
      default: '1'
    }
  },
  methods: {
    cl() {
      this.isShow = true
    },
    close() {
      this.isShow = false
    },
    open() {
      this.isShow = true
    },
    //  赋值
    inputContent(res) {
      this.questionContent = res || ''
    }
  },
  mounted() {
    fn = (e) => {
      /* eslint-disable */
      if (e.keyCode == 13) {
        e.preventDefault()

        this.$emit('content', {
          question: this.questionContent,
          renew: false
          // knowledge_base_id: this.value
        })
        return this.inputContent()
      }
    }
    this.$nextTick(() => {
      if (document.getElementById('textarea')) {
        document.getElementById('textarea').addEventListener('keydown', fn)
      }
    })
  },
  watch: {
    isShow(val) {
      if (val) {
        fn = (e) => {
          /* eslint-disable */
          if (e.keyCode == 13) {
            e.preventDefault()
            this.$emit('content', {
              question: this.questionContent,
              // knowledge_base_id: this.value
              renew: false
            })
            return this.inputContent()
          }
        }
        this.$nextTick(() => {
          document.getElementById('textarea').addEventListener('keydown', fn)
        })
      }
    }
  },
  beforeDestroy() {
    if (document.getElementById('textarea'))
      document.getElementById('textarea').removeEventListener('keydown', fn)
  }
}
</script>

<style lang="stylus" scoped>
.chatRobotFloor {
  width: 824px;
  height: 130px;
  margin 0 auto
  padding-top:20px

  .chatRobotDiv {
    width: 100%;
    padding: 6px 4px;
    font-size: 12px;
    display: flex;
    align-items: center;
    .questionInput {
      width: 116px;
      ::v-deep .el-input__inner {
        background-color: rgba(40, 46, 83, 0.05);
        height: 19px;
      }
      ::v-deep .el-input__suffix {
        top: 3px;
      }
      ::v-deep .el-input__icon {
        line-height: inherit;
      }
      ::v-deep .el-input__suffix-inner {
        display: inline-block;
      }
    }
  }

  ::v-deep .chatQuestionLib .el-input {
    width: 96px;
    height: 16px;

    .el-input__inner {
      background: rgba(40, 46, 83, 0.05);
    }
  }

  textarea::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 0.3);
  }

  .chatRobotBtnDiv {
    width: 85px;
    height: 19px;
    background: linear-gradient(270deg, #3292ff 0%, #1c60ff 100%);
    border-radius: 3px;
    text-align: center;
    line-height: 19px;
    font-size: 10px;
    font-family: MicrosoftYaHeiUI;
    color: #ffffff;
  }

  .chatTextarea {
    width: 100%;
    height: 100px;
    max-height: 100px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.04);
    border-radius: 6px;
    padding: 5px 10px;

    .textarea {
      width: 100%;
      height: 66px;
      color: #606266;
      font-size: 14px;
      resize: none;
      border: 0;
      overflow-y: auto;
      word-wrap: break-word;
      word-break: break-word;
      line-height: 20px;
      border-radius: 5px;
      outline: none;
      background: none;


    }
  }

  ::v-deep .el-textarea__inner {
    border: none !important;
  }
}
</style>
